import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';
import Help from '../../../generics/help';

const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

require('datatables.net-buttons/js/dataTables.buttons.min' );

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const jzip = require( 'jszip');
require( 'datatables.net-buttons/js/buttons.html5.min' );
window.JSZip = jzip;

var session = sessionStorage.getItem('health_facilities_name');
var Config = require('../../../../config');
var report = require('../../../generics/report_head');

class IncomeBook extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.searching = this.searching.bind(this);
		this.isValidForm = this.isValidForm.bind(this);
		this.showCtrlError = this.showCtrlError.bind(this);

		this.setTable = this.setTable.bind(this);
		this.dateCompare = this.dateCompare.bind(this);
		this.getConvokePlace = this.getConvokePlace.bind(this);

		this.state = {
			health_facilities_id:"all",
			health_facilities: [],
			start_date 	: "",
			end_date 	: "",
			start_folio : "",
			end_folio 	: "",
			type:"fecha",
			listado:[],
			columns:[
				{title:'Fecha - Hra Donación', width:'125px'},
				{title:'Donador'},
				{title:'No. Unidad'},
				{title:'Procedencia'},
				{title:'T. Donación'},
				{title:'Comp + Vol'},
				{title:'F. Caducidad'},
				{title:'HGB'},
				{title:'HTO'},
				{title:'Gpo & RH'},
			],
			filename:"Libreta Ingresos",
			type_name:"",
			date_hour:"",
			medical:"",
			convoke_places:[],
			convoke_places_id:"",
		}
	}

	componentWillMount(){
		var medical = JSON.parse(sessionStorage.getItem('medical_staff'));

		this.setState({
			//health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			medical:(medical.lastname1 !== null ? medical.lastname1 : "")+' '+
					(medical.lastname2 !== null ? medical.lastname2 : "")+' '+medical.names
		});

		if(!this.props.hiddeToReport){
			this.props.reload();
		}
	}

	componentDidMount(){
		this.props.waiting.handleShow('Cargando...');
		setTimeout(()=>{
			this.props.waiting.handleClose();
		}, 300)
		fetch(Config.default.apiGateway.URL+'health_facilities', {
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					health_facilities: response
				});
			}
		});

		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			var aux = response.split('|');
			var date = aux[0].split("/");
			var hours = this.getHourFormat(aux[1]);

			this.setState({
				start_date:date[2]+'-'+date[1]+'-'+date[0],
				end_date:date[2]+'-'+date[1]+'-'+date[0],
				date_hour:aux[0]+' '+hours,
			});
		})

		//this.getConvokePlace();

		this.setTable();
	}

	getConvokePlace(){
		var health = this.state.health_facilities_id;
 		
 		if(sessionStorage.getItem('matriz') === '1' && health === sessionStorage.getItem('health_facilities_id')){
 			health = 'all';
 		}

 		fetch(Config.default.apiGateway.URL+'convoke_places/by_hf?health_facilities_id='+health, {
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					convoke_places: response
				});
			}
		});
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}


	setTable(){
		var fechas = "Información Del: "+(this.state.start_date !== "" ? moment(this.state.start_date).format("DD/MM/YYYY"): '')+ 
					" Al: "+(this.state.end_date !== "" ? moment(this.state.end_date).format("DD/MM/YYYY") : '') 
		
		this.$el = $(this.el);

		var table = this.$el.DataTable({
			aoColumnDefs: [
			   { "sWidth": "160px", "aTargets": [0] },
			   { "sWidth": "150px", "aTargets": [1] },
			   { "sWidth": "70px", "aTargets": [2] },
			   { "sWidth": "150px", "aTargets": [3] },
			   { "sWidth": "130px", "aTargets": [4] },
			   { "sWidth": "80px", "aTargets": [5] },
			   { "sWidth": "95px", "aTargets": [6] },
			   { "sWidth": "100px", "aTargets": [9] }
			],
			dom: 'Bfrtip',
			buttons: [
				{
                	extend: 'excelHtml5',
                	title: this.state.filename
            	},
            	{
                	extend: 'pdfHtml5',
                	title: this.state.filename,
                	orientation:'landscape',
                	customize: (doc)=> { 
                		doc.content.unshift({
							image: this.props.header_document,
							alignment:'center',
							width:this.props.w_head
						});
						doc.content.splice(2, 0, {text: fechas+'\t\t\t'+this.state.medical, margin:[10,0,0,10] });
					
                		doc.styles.tableHeader.fontSize = 6.5;
                		doc.defaultStyle.fontSize = 6.5; //2,3,4,etc doc.styles.tableHeader.fontSize = 1; //2, 3, 4, etc 
                		doc.footer = {text: this.state.date_hour+'\t-\t'+this.state.medical, alignment: 'right',margin: [ 0, 0, 50, 0 ]};
                	} 
            	},
            ],
			data: this.state.listado,
			columns:this.state.columns,
			oLanguage:{
				"sProcessing":"Procesando...",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",
				"sInfoPostFix":"",
				"sSearch":"Buscar:",
				"sUrl":"",
				"sInfoThousands":",",
				"sLoadingRecords":"Cargando...",
				"fnInfoCallback":null,
			},
			paging:false,
			responsive:true,
			searching: false,
			scrollY:"32em",
			scrollX: true,
			autoWidth: true,
			info:false,
		});

		if (table.rows().indexes().length === 0 ) {
			table.buttons('.buttons-html5').disable();
		}else {
			table.buttons('.buttons-html5').enable();
		}

	}

	handleChange(e){
		this.setState({
			[e.target.name]: e.target.value
		});

		if(e.target.name === 'health_facilities_id'){
			setTimeout(()=>{
				this.getConvokePlace();
			}, 500);
		}

		var control = document.getElementById(e.target.name);
		
		if(control.required && control.className.includes('error')){
			control.classList.remove('error');
		}

		if(e.target.name === 'type'){
			if(e.target.value === 'fecha'){
				this.setState({start_folio:"", end_folio:""});
			}else{
				this.setState({start_date:"", end_date:""});
			}
		}

	}

	searching(){
		var columns = [
			{title:'Fecha - Hra Donación', width:'100px'},
			{title:'Donador',width:'150px'},
			{title:'No. Unidad',width:'100px'},
			{title:'Procedencia',width:'150px'},
			{title:'T. Donación + T. Extracción',width:'100px'},
			{title:'Comp + Vol',width:'100px'},
			{title:'F. Caducidad',width:'100px'},
			{title:'HGB',width:'60px'},
			{title:'HTO', width:'60px'},
			{title:'Gpo & RH',width:'100px'},
		];


		
		if(this.isValidForm()){
			if(this.dateCompare()){
				var obj = {
					start_date:this.state.start_date,
					end_date:this.state.end_date,
					start_folio:this.state.start_folio,
					end_folio:this.state.end_folio,
					health_facilities_id:sessionStorage.getItem('health_facilities_id'),
					convoke_places_id: this.state.convoke_places_id,
				};
				
				this.props.waiting.handleShow('Buscando...');
				fetch(Config.default.apiGateway.URL+'reports/incomes_book',{
					method: 'POST',
					body:JSON.stringify(obj),
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					this.props.waiting.handleClose();
					if(res.ok){
						return res.json();
					}else{
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
					}
				}).then(response => {
					if(response !== undefined){
						response.test_serology.map((s, i)=>{
							columns.push({title:s.code, id:s.id})
						});

						var list = [];
						response.res.map((r, i)=>{
							var obj = [
								r.donation_date+' '+
								(r.donation_hour !== null ? 
									moment(r.donation_hour, 'HH:mm:ss').format('HH:mm')
								: ''),
								r.donor_name,
								r.unit_number,
								r.donation_center,
								r.donation_type
							]

							var comp_offer = '';
							var cad_comp_offer = '';
							if(r.division_units !== null){
								if(r.division_units.length > 0){
									r.division_units.map((c, j)=>{
										comp_offer += c.volume+(j === r.division_units.length - 1 ? '' : ', ');

										cad_comp_offer += c.caducidad+(j === r.division_units.length - 1 ? '' : ', ')
									})
								}else{
									comp_offer += r.division_units.volume !== undefined ? r.division_units.volume : "";

									cad_comp_offer += r.division_units.caducidad !== undefined ? r.division_units.caducidad : "";
								}
									
							}
								
							obj.push(comp_offer, cad_comp_offer);

							obj.push(
								r.hgb_donor,
								r.hto_donor,
								r.unit_group_rh
							)

							columns.map((c, i)=>{
								if(c.id !== undefined){
									var index = r.serology_results.findIndex(item => item.analitical_test_id === c.id);

									if(index !== -1){
										obj.push(r.serology_results[index].value);
									}else{
										obj.push('');
									}
								}

								
							})
							
							list.push(obj);

						})

						setTimeout(()=>{
							this.props.waiting.handleShow('Cargando...');
							this.$el = $(this.el);
							this.$el.DataTable().destroy();
							this.$el.empty();
						}, 500);

						setTimeout(()=>{
							this.props.waiting.handleClose();
							this.setTable();
						}, 1000);

						this.setState({
							listado: list,
							columns: columns
						});
						
					}
				});
			}else{
				swal('Error', 'La Fecha Hasta debe ser mayor o igual a Fecha Desde', 'error');
			}
		}else{
			swal('Error', 'Campos Incompletos', 'error');
		}
	}

	dateCompare(){
		var ini = moment(this.state.start_date);
		var fin = moment(this.state.end_date);
		var date_ok = true;

		if (this.state.type == 'fecha'){
			if(ini !== 'Invalid date' && fin !== 'Invalid date'){
				if(fin < ini){
					date_ok = false;
					document.getElementById('end_date').classList.add('error');
				}else{
					document.getElementById('end_date').classList.remove('error');
				}
			}else{
				date_ok = false;
			}		
		}
		return date_ok;
	}

	isValidForm() {
		const select = document.querySelector('form');
		const inputs = select.querySelectorAll('input, select');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		    	
		   
		  	}
	    });	    

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
					{session} ->
					{t('sidebar.nav.reports.MAIN')} ->
					Donantes ->
					{this.state.filename}
					</h5>
				</div>
				<Help 
					{...this.props}
	                menu={"help_patients"} 
	                submenu={"help_incomes_book"}  />
				<div className="form-group" style={{paddingLeft:"0.5em"}}>
					

					<div className="col-xs-12">
						<form noValidate>
							<div className="col-xs-12 col-sm-2" style={{borderRight:"1px solid #e0e0e0"}}>
								<div className="col-xs-12 form-group">
									<span className="span-min">Centro Origen</span>
									<select type="text" name="health_facilities_id" id="health_facilities_id" 
										value={this.state.health_facilities_id} onChange={this.handleChange}
										className="form-control" required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.health_facilities.map((h, i)=>{
											return <option key={i} value={h.id}>
												{h.name}
											</option>
										})}
									</select>
								</div>
								<div className="col-xs-12 form-group">
									<span className="span-min">Lugar de Colecta</span>
									<select className="form-control" name="convoke_places_id" id="convoke_places_id"
										value={this.state.convoke_places_id} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.convoke_places.map((c, i)=>{
											return <option key={i} value={c.id}>
												{c.name}
											</option>
										})}
									</select>
								</div>

								<div className="col-xs-12 form-group">
									<span className="span-min">Tipo</span>
									<select className="form-control" name="type" id="type" 
										value={this.state.type} onChange={this.handleChange} required>
										<option value="fecha">FECHA</option>
										<option value="folio">FOLIO</option>
									</select>
								</div>
								

								{this.state.type === 'folio' ?
									<div>
										<div className="col-xs-12 form-group">
											<span className="span-min">Folio Desde</span>
											<input className="form-control hour-input" name="start_folio" id="start_folio"
												value={this.state.start_folio} onChange={this.handleChange} required />
										</div>
										<div className="col-xs-12 form-group">
											<span className="span-min">Folio Hasta</span>
											<input className="form-control hour-input" name="end_folio" id="end_folio"
												value={this.state.end_folio} onChange={this.handleChange} required />
										</div>
									</div>
								: <div>
									<div className="col-xs-12 form-group">
										<span className="span-min">Fecha Desde</span>
										<input type="date" className="form-control hour-input" name="start_date" id="start_date"
											value={this.state.start_date} onChange={this.handleChange} required />
									</div>
									<div className="col-xs-12 form-group">
										<span className="span-min">Fecha Hasta</span>
										<input type="date" className="form-control hour-input" name="end_date" id="end_date"
											value={this.state.end_date} onChange={this.handleChange} required />
									</div>
								</div>}
								
								
								<div style={{textAlign:"right"}}>
									<button type="button" className="btn btn-info" onClick={this.searching} style={{fontSize:"1em"}}>
										Buscar
									</button>
								</div>
							</div>

							<div className="col-xs-12 col-sm-10">
								<div className="col-xs-12" style={{marginTop:"20px",textAlign: "center",fontWeight: "bold",textDecoration: "underline",fontSize:'16px'}}>
									<span>
										{this.state.filename}
									</span>
								</div>
								<div className="col-xs-12" >
									<span>
										Información Del:  {this.state.start_date !== "" ?
											moment(this.state.start_date).format("DD/MM/YYYY")
										: ''}    
									</span>
									<span style={{marginLeft:"5px"}}>	
										Al: {this.state.end_date !== "" ?
											moment(this.state.end_date).format("DD/MM/YYYY")
										: ''}
									</span>
								</div>


								<div className="col-xs-12" id="table-to-pdf">
									<div className="table-responsive">
										<table style={{fontSize:"11px"}} className={'expenses-discards'} id="table-to-xls" width="100%" ref={el => this.el = el}>
										</table>
									</div>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		)
	}
}

export default translate('translations') (IncomeBook);